
<div class="qrcodeImage">
    <qrcode
      [qrdata]="data"
      [allowEmptyString]="true"
      [cssClass]="'center'"
      [colorDark]="'#1e252d'"
      [colorLight]="'#FFFFFF'"
      [elementType]="'canvas'"
      [errorCorrectionLevel]="errorLevel"
      [imageSrc]="'./assets/favicon.png'"
      [imageHeight]="25"
      [imageWidth]="25"
      [margin]="margin ? margin : 8"
      [scale]="1"
      [width]="width ? width : 500"
    ></qrcode>
  </div>

  <!--#05ffad-->
